<template>
  <div id="measure-distance-container" style="cursor: crosshair; height: 100%; width: 100%; position: absolute; top: 0px; left: 0px; z-index: 1; pointer-events: none;">
    <div  style="pointer-events: auto; position: absolute; top: 5px; right: 5px;">
      <v-btn :color="measuring ? 'primary' : ''" @click="measuring = !measuring" v-tooltip="'Mittaa etäisyyksiä'" small>
        <v-icon>mdi-ruler</v-icon>
      </v-btn>
      <v-btn @click="settings = true" class="ml-1" v-tooltip="'Valitse kalibrointipisteet'" small>
        <v-icon color="red">mdi-dots-circle</v-icon>
      </v-btn>
      <v-btn @click="editPointsMenu = true" class="ml-1" v-tooltip="'Muokkaa kiinnostuspisteitä'" small>
        <v-icon color="blue">mdi-dots-vertical</v-icon>
      </v-btn>
      <!-- <v-btn :color="hor.visible ? 'primary' : ''" class="ml-1" @click="hor.visible = !hor.visible" v-tooltip="'Vaakaviiva'" small>
        <v-icon>mdi-minus</v-icon>
      </v-btn> -->
    </div>

    <!-- Points of interest edit menu -->
    <v-menu
      v-model="editPointsMenu"
      absolute
      offset-y
      :close-on-click="false"
      :close-on-content-click="false"
    >
      <v-card min-width="300" style="z-index: 100;">
        <v-card-title>
          Muokkaa kiinnostuspisteitä
          <v-spacer></v-spacer>
          <v-btn icon small @click="editPointsMenu = false; selectedPoint = null;">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-select
            v-model="selectedPoint"
            :items="all_points_of_interest"
            item-text="real_name"
            item-value="name"
            label="Valitse piste"
            @change="startPointEdit"
            :menu-props="{ closeOnClick: false, closeOnContentClick: false }"
          ></v-select>
          <div v-if="selectedPoint" class="mt-4">
            <div class="text-subtitle-2 mb-2">Klikkaa uutta sijaintia</div>
            <div class="d-flex align-center">
              <v-icon class="mr-2">mdi-cursor-default-click</v-icon>
            </div>
            <div class="d-flex">
              <v-spacer></v-spacer>
              <v-btn text color="primary" class="mt-2" @click="selectedPoint = null">Valmis</v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-menu>

    <v-dialog max-width="500" v-model="settings">
      <measure-distance-settings @close="settings = false; savePoints();" v-model="points"></measure-distance-settings>
    </v-dialog>
    <svg
      width="100%"
      height="100%"
      preserveAspectRatio="xMidYMid meet"
      @click="handleClick"
      @mousemove="onDrag"
      @mouseup="stopDrag"
      @touchmove="onDrag"
      @touchend="stopDrag"
      style="pointer-events: auto;"
    >
      <!-- Horizontal line -->
      <!-- <g v-if="hor.visible">
        <line
          key="hor-line"
          :x1="hor.x"
          :y1="hor.y"
          :x2="hor.width + hor.x"
          :y2="hor.y"
          stroke="blue"
          stroke-width="1"
        />
        <circle
          key="hor-ball"
          :cx="hor.x + hor.width"
          :cy="hor.y"
          :r="hor.r"
          stroke-width="2"
          fill="blue"
          @mousedown="startDrag(null, 'hor')"
          @touchstart="startDrag(null, 'hor')"
          stroke="blue"
          :style="`cursor: pointer;`"
        />
      </g> -->

      <!-- LINE FOR MEASURING DISTANCE -->
      <g v-if="measuring">
        <line
          v-if="previous_point && latest_point"
          :x1="previous_point.x"
          :y1="previous_point.y"
          :x2="latest_point.x"
          :y2="latest_point.y"
          stroke="blue"
          stroke-width="2"
        />
        <line
          v-else-if="previous_point && mouse_point"
          :x1="previous_point.x"
          :y1="previous_point.y"
          :x2="mouse_point.x"
          :y2="mouse_point.y"
          stroke="blue"
          stroke-width="2"
        />
        <text
          v-if="distanceText && distance"
          :x="distanceText.x"
          :y="distanceText.y + 15"
          text-anchor="middle"
          fill="white"
          font-size="16"
        >
          {{ distance.toFixed(2) }} m
        </text>
      </g>

      <!-- Base line -->
      <g v-if="baseLine">
        <circle
          v-for="(point, index) in baseLineTenCentimeters"
          :key="'base-10cm-dot-' + index"
          :cx="point.x"
          :cy="point.y"
          r="0.35"
          fill="black"
          stroke="black"
          stroke-width="0.35"
        />
        <circle
          v-for="(point, index) in baseLine"
          :key="'base-dot-' + index"
          :cx="point.x"
          :cy="point.y"
          r="1"
          fill="red"
          stroke="red"
          stroke-width="1"
        />
        <text
          v-for="(point, index) in baseLine"
          :key="'base-text-' + index"
          :x="point.x"
          :y="point.y + 10"
          text-anchor="middle"
          fill="white"
          font-size="6"
        >
          {{ index + 1 }}
        </text>
      </g>

      <!-- First to second base line -->
      <g v-if="firstToSecondLine">
        <circle
          v-for="(point, index) in firstToSecondLineTenCentimeters"
          :key="'first-second-10cm-dot-' + index"
          :cx="point.x"
          :cy="point.y"
          r="0.35"
          fill="black"
          stroke="black"
          stroke-width="0.35"
        />
        <circle
          v-for="(point, index) in firstToSecondLine"
          :key="'first-second-dot-' + index"
          :cx="point.x"
          :cy="point.y"
          r="1"
          fill="red"
          stroke="red"
          stroke-width="1"
        />
        <text
          v-for="(point, index) in firstToSecondLine"
          :key="'first-second-text-' + index"
          :x="point.x"
          :y="point.y + 10"
          text-anchor="middle"
          fill="white"
          font-size="6"
        >
          {{ index + 1 }}
        </text>
      </g>

      <line
        v-for="(connection, index) in connections"
        :key="'line-'+index"
        :x1="connection.start.x"
        :y1="connection.start.y"
        :x2="connection.end.x"
        :y2="connection.end.y"
        stroke="black"
        stroke-width="1"
      />
      <circle
        v-for="circle in points_in_use"
        :key="'circle-'+circle.id"
        :cx="circle.x"
        :cy="circle.y"
        r="8"
        stroke-width="2"
        fill="transparent"
        @mousedown="startDrag($event, circle.id)"
        @touchstart="startDrag($event, circle.id)"
        :stroke="selectedPoint === circle.name ? 'pink' : 'red'"
        :style="`cursor: ${selectedPoint ? 'none' : 'crosshair'}; pointer-events: auto;`"
      />
      <!-- POINTS OF INTEREST -->
      <circle
        v-for="(circle, i) in mapped_non_editing_points_of_interest"
        :key="'circle-interest-'+i"
        :cx="circle.x"
        :cy="circle.y"
        r=".5"
        stroke-width="2"
        fill="transparent"
        stroke="blue"
        :style="`pointer-events: none;`"
      />
      <!-- Highlight the point being edited -->
      <template v-if="selectedPoint && mapped_editing_point">
        <circle
          :cx="mapped_editing_point.x"
          :cy="mapped_editing_point.y"
          r="2"
          stroke-width="2"
          fill="yellow"
          stroke="orange"
          :style="`pointer-events: none; opacity: 0.7;`"
        />
      </template>
      <text
        v-for="circle in points_in_use"
        :key="'text-'+circle.id"
        :x="circle.x"
        :y="circle.y + 25"
        text-anchor="middle"
        fill="white"
        font-size="14"
      >
        {{ circle.name }}
      </text>
    </svg>
  </div>
</template>

<script>
import { transformPoint, computePerspectiveTransform, getMatrixInverse } from '@/utils/measure/matrixHelper.js'
import MeasureDistanceSettings from './MeasureDistanceSettings.vue';
import { mapActions, mapGetters } from 'vuex/dist/vuex.common.js';
import { analyzeLine } from '@/utils/measure/pointUtils';
import { roundToN } from '@/utils/measure/round';

export default {
  components: { MeasureDistanceSettings },
  created() {
    this.$nextTick(() => {
      const el = document.getElementById('measure-distance-container')
      this.width = el.offsetWidth
      this.height = el.offsetHeight

      window.addEventListener('resize', () => {
        this.width = el.offsetWidth
        this.height = el.offsetHeight
      })
    })

    this.initLeagueMapBases({ league_id: this.video.league_id})
      .then(() => {
        this.$nextTick(() => {
          if(this.chosen_map_base && this.chosen_map_base.dimensions) {
            this.points = JSON.parse(this.chosen_map_base.dimensions).dimensions.map(p => ({ ...p, in_use: true }))
          }

          if(window.localStorage.tiimi_points) {
            const points = JSON.parse(window.localStorage.tiimi_points)

            this.points = this.points.map(p => { return { ...p, in_use: false } })

            points.forEach(p => {
              const point = this.points.find(pp => pp.id === p.id)
              if(point) {
                point.x = p.x // both relative
                point.y = p.y
                point.in_use = true
              }
            })
          }

          this.stopDrag()
        })
      })
  },
  data() {
    return {
      width: 0,
      height: 0,
      settings: false,
      editPointsMenu: false,
      menuX: 0,
      menuY: 0,
      selectedPoint: null,
      menuDragStart: { x: 0, y: 0 },
      menuPosition: { x: 0, y: 0 },
      isDraggingMenu: false,
      points: [
        // { in_use: true, name: "3-puoli takakulma", id: "left_back", x: 100, y: 100, ideal_x: 0, ideal_y: 0 },
        // { in_use: true, name: "2-puoli takakulma", id: "right_back", x: 300, y: 100, ideal_x: 42, ideal_y: 0 },
        { in_use: true, name: "2-puoli kulma ", id: "right_corner", x: 300, y: 300, ideal_x: 42, ideal_y: 64 },
        { in_use: true, name: "2-puoli kotipesän kulma ", id: "right_home", x: 250, y: 400, ideal_x: 28, ideal_y: 96 },
        { in_use: true, name: "3-puoli kotipesän kulma ", id: "left_home", x: 150, y: 400, ideal_x: 14, ideal_y: 96 },
        { in_use: true, name: "3-puoli kulma ", id: "left_corner", x: 100, y: 300, ideal_x: 0, ideal_y: 64 },
      ],
      draggedId: null,
      matrix: null,
      inverse_matrix: null,
      previous_point: null,
      mouse_point: null,
      latest_point: null,
      measuring: false,
      hor: {
        x: 10,
        y: 10,
        width: 300,
        r: 5,
        visible: true
      }
    }
  },
  computed: {
    ...mapGetters('map', [
      'chosen_map_base'
    ]),
    ...mapGetters('videos', [
      'video'
    ]),
    firstToSecondLine() {
      if (!this.matrix || !this.all_points_of_interest) return null;

      const firstBase = this.all_points_of_interest.find(p => p.name === 'first_base_tip');
      const secondBase = this.all_points_of_interest.find(p => p.name === 'second_base_tip');

      if (!firstBase || !secondBase) return null;

      const points = [];
      const startX = firstBase.ideal_x;
      const startY = firstBase.ideal_y;
      const endX = secondBase.ideal_x;
      const endY = secondBase.ideal_y;

      // Calculate total distance
      const totalDistance = Math.sqrt(
        Math.pow(endX - startX, 2) + Math.pow(endY - startY, 2)
      );

      // Create exactly 10 points, starting 1 meter from first_base_tip
      for (let i = 1; i <= 5; i++) {
        const distance = i; // Each point is 1 meter apart
        const ratio = distance / totalDistance;
        const x = startX + (endX - startX) * ratio;
        const y = startY + (endY - startY) * ratio;

        const point = transformPoint([x, y], this.inverse_matrix);
        points.push({
          x: point[0],
          y: point[1]
        });
      }

      return points;
    },
    firstToSecondLineTenCentimeters() {
      if (!this.matrix || !this.all_points_of_interest) return null;

      const firstBase = this.all_points_of_interest.find(p => p.name === 'first_base_tip');
      const secondBase = this.all_points_of_interest.find(p => p.name === 'second_base_tip');

      if (!firstBase || !secondBase) return null;

      return this.pointsAlongLine(firstBase, secondBase, 5, 0.1)
    },
    baseLine() {
      if (!this.matrix || !this.all_points_of_interest) return null;

      const secondBase = this.all_points_of_interest.find(p => p.name === 'second_base_tip');
      const thirdBase = this.all_points_of_interest.find(p => p.name === 'third_base_tip');

      if (!secondBase || !thirdBase) return null;

      const points = [];
      const startX = secondBase.ideal_x;
      const startY = secondBase.ideal_y;
      const endX = thirdBase.ideal_x;
      const endY = thirdBase.ideal_y;

      // Calculate total distance
      const totalDistance = Math.sqrt(
        Math.pow(endX - startX, 2) + Math.pow(endY - startY, 2)
      );

      // Create exactly 10 points, starting 1 meter from second_base_tip
      for (let i = 1; i <= 10; i++) {
        const distance = i; // Each point is 1 meter apart
        const ratio = distance / totalDistance;
        const x = startX + (endX - startX) * ratio;
        const y = startY + (endY - startY) * ratio;

        const point = transformPoint([x, y], this.inverse_matrix);
        points.push({
          x: point[0],
          y: point[1]
        });
      }

      return points;
    },
    baseLineTenCentimeters() {
      if (!this.matrix || !this.all_points_of_interest) return null;

      const secondBase = this.all_points_of_interest.find(p => p.name === 'second_base_tip');
      const thirdBase = this.all_points_of_interest.find(p => p.name === 'third_base_tip');

      if (!secondBase || !thirdBase) return null;

      return this.pointsAlongLine(secondBase, thirdBase, 10, 0.1)
    },
    gridPoints() {
      if (!this.matrix || !this.ideals) return [];

      const points = [];
      const width = this.ideals.width;
      const height = this.ideals.height;

      // Create points at 1-meter intervals
      for (let y = 0; y <= height; y += 1) {
        for (let x = 0; x <= width; x += 1) {
          const point = transformPoint([x, y], this.inverse_matrix);
          points.push({
            x: point[0],
            y: point[1]
          });
        }
      }

      return points;
    },
    mapped_points_of_interest() {
      if(!this.matrix) return []
      return this.all_points_of_interest.map(p => {
        const point = transformPoint([p.ideal_x, p.ideal_y], this.inverse_matrix)
        return { x: point[0], y: point[1] }
      })
    },
    all_points_of_interest() {
      if(!this.dimensions) return []
      return this.dimensions.points_of_interest
    },
    distanceText() {
      if(!this.previous_point) return null
      if(this.latest_point) return analyzeLine(this.previous_point, this.latest_point).midpoint
      else return analyzeLine(this.previous_point, this.mouse_point).midpoint
    },
    distance() {
      if(!this.previous_point) return null
      let second_point = this.latest_point ? this.latest_point : this.mouse_point
      return this.calculateDistance([this.previous_point.ideal_x, this.previous_point.ideal_y], [second_point.ideal_x, second_point.ideal_y])
    },
    points_in_use() {
      return this.points.filter(p => p.in_use).map(p => {
        return {
          x: Math.min(p.x, this.width),
          y: Math.min(p.y, this.height),
          ideal_x: p.ideal_x,
          ideal_y: p.ideal_y,
          id: p.id,
          name: p.name
        }
      })
    },
    ideals() {
      if(!this.dimensions) return { width: 0, height: 0 }
      return this.dimensions.ideals
    },
    points_of_interest() {
      if(!this.dimensions) return []
      return this.dimensions.points_of_interest
    },
    dimensions() {
      if(!this.chosen_map_base) return null
      if(!this.chosen_map_base.dimensions) return null
      return JSON.parse(this.chosen_map_base.dimensions)
    },
    connections() {
      let cons = []

      for(let i = 0; i < this.points_in_use.length; i++) {
        cons.push({
          start: this.points_in_use[i],
          end: this.points_in_use[(i + 1) % this.points_in_use.length]
        })
      }

      return cons
    },
    mapped_non_editing_points_of_interest() {
      if (!this.matrix) return [];
      return this.all_points_of_interest
        .filter(p => !this.selectedPoint || p.name !== this.selectedPoint)
        .map(p => {
          const point = transformPoint([p.ideal_x, p.ideal_y], this.inverse_matrix);
          return { x: point[0], y: point[1] };
        });
    },
    mapped_editing_point() {
      if (!this.selectedPoint || !this.matrix) return null;
      const p = this.all_points_of_interest.find(p => p.name === this.selectedPoint);
      if (!p) return null;
      const point = transformPoint([p.ideal_x, p.ideal_y], this.inverse_matrix);
      return { x: point[0], y: point[1] };
    }
  },
  methods: {
    ...mapActions('analysis', [
      'pointClicked',
      'mouseMoved'
    ]),
    ...mapActions('map', [
      'initLeagueMapBases',
      'updatePointOfInterest'
    ]),
    handleClick(event) {
      const svgP = this.transform(event)

      if(!this.matrix) return null

      const point = transformPoint([svgP.x, svgP.y], this.matrix)
      // If we're editing a point of interest, update its position
      if (this.selectedPoint) {
        this.$store.dispatch('map/updatePointOfInterest', {
          name: this.selectedPoint,
          ideal_x: point[0],
          ideal_y: point[1]
        });
        // Do not set selectedPoint to null here; user must click 'Valmis' (Done)
        return;
      }

      let distance_from_previous = null
      if(!this.previous_point || (this.previous_point && this.latest_point) && this.measuring) {
        this.previous_point = {
          x: svgP.x,
          y: svgP.y,
          ideal_x: point[0],
          ideal_y: point[1]
        }
        this.latest_point = null
      } else if(this.measuring) {
        this.latest_point = {
          x: svgP.x,
          y: svgP.y,
          ideal_x: point[0],
          ideal_y: point[1]
        }
        distance_from_previous = roundToN(this.calculateDistance([this.previous_point.ideal_x, this.previous_point.ideal_y], [this.latest_point.ideal_x, this.latest_point.ideal_y]), 2)
      }

      let distances = this.all_points_of_interest.map(p => {
        return {
          name: p.name,
          distance: roundToN(this.calculateDistance([p.ideal_x, p.ideal_y], [point[0], point[1]]), 2),
          distance_x: roundToN(Math.abs(p.ideal_x - point[0]), 2),
          distance_y: roundToN(Math.abs(p.ideal_y - point[1]), 2)
        }
      })
      const relative_point = {
        point: [ point[0] / this.ideals.width, point[1] / this.ideals.height ],
        ideal_point: [ point[0], point[1] ],
        distances,
        distance_from_previous
      }

      this.pointClicked(relative_point)
      this.last_point_ideal = [point[0], point[1]]
    },
    calculateDistance(point1, point2) {
      const [x1, y1] = point1;
      const [x2, y2] = point2;

      const deltaX = x2 - x1;
      const deltaY = y2 - y1;

      return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    },
    pointsAlongLine(start, end, maxDistance, step) {
      const points = []
      const totalDistance = Math.sqrt(
        Math.pow(end.ideal_x - start.ideal_x, 2) + Math.pow(end.ideal_y - start.ideal_y, 2)
      )

      for(let distance = step; distance <= maxDistance; distance += step) {
        const roundedDistance = Number(distance.toFixed(1))
        if(Number.isInteger(roundedDistance)) continue

        const ratio = roundedDistance / totalDistance
        const x = start.ideal_x + (end.ideal_x - start.ideal_x) * ratio
        const y = start.ideal_y + (end.ideal_y - start.ideal_y) * ratio
        const point = transformPoint([x, y], this.inverse_matrix)

        points.push({
          x: point[0],
          y: point[1]
        })
      }

      return points
    },
    transform(event) {
      const svg = this.$el.querySelector('svg')
      const pt = svg.createSVGPoint()

      pt.x = event.touches ? event.touches[0].clientX : event.clientX
      pt.y = event.touches ? event.touches[0].clientY : event.clientY

      const svgP = pt.matrixTransform(svg.getScreenCTM().inverse())

      return svgP
    },
    startDrag(event, id) {
      this.draggedId = id
    },
    onDrag(event) {
      if (!this.draggedId) this.handleMouseMove(event)

      if(this.draggedId === 'hor') {
        const svgP = this.transform(event)
        this.hor = { ...this.hor, x: svgP.x - this.hor.width, y: svgP.y }
      }

      if (this.draggedId && this.draggedId.startsWith('point_')) {
        const svgP = this.transform(event)
        const pointName = this.draggedId.replace('point_', '');
        const point = this.all_points_of_interest.find(p => p.name === pointName);
        if (point) {
          const transformedPoint = transformPoint([svgP.x, svgP.y], this.matrix);
          point.ideal_x = transformedPoint[0];
          point.ideal_y = transformedPoint[1];
        }
      }

      const svgP = this.transform(event)

      this.points = this.points.map(circle =>
        circle.id === this.draggedId
          ? { ...circle, x: svgP.x, y: svgP.y }
          : circle
      )
    },
    savePoints() {
      window.localStorage.tiimi_points = JSON.stringify(this.points_in_use)
    },
    handleMouseMove(event) {
      const svgP = this.transform(event)
      let point = transformPoint([svgP.x, svgP.y], this.matrix)
      this.mouse_point = {
        x: svgP.x,
        y: svgP.y,
        ideal_x: point[0],
        ideal_y: point[1]
      }

      point = [ point[0] / this.ideals.width, point[1] / this.ideals.height ]
      this.mouseMoved(point)
    },
    stopDrag() {
      this.draggedId = null
      const TwoDPoints = this.points_in_use.map(c => [ c.ideal_x, c.ideal_y ])
      const imagePoints = this.points_in_use.map(c => [ c.x, c.y ])
      this.matrix = computePerspectiveTransform(imagePoints, TwoDPoints)
      this.inverse_matrix = getMatrixInverse(this.matrix)

      this.savePoints()
    },
    absToRel(point) {
      if(!this.width || !this.height) return null
      if(!point[0] || !point[1]) return null
      return [ point[0] / this.width, point[1] / this.height ]
    },
    relToAbs(point) {
      if(!this.width || !this.height) return null
      if(!point[0] || !point[1]) return null
      return [ point[0] * this.width, point[1] * this.height ]
    },
    startPointEdit(pointName) {
      this.selectedPoint = pointName;
    },
    startMenuDrag(event) {
      this.isDraggingMenu = true;
      this.menuDragStart = {
        x: event.clientX || event.touches[0].clientX,
        y: event.clientY || event.touches[0].clientY
      };
      document.addEventListener('mousemove', this.onMenuDrag);
      document.addEventListener('mouseup', this.stopMenuDrag);
      document.addEventListener('touchmove', this.onMenuDrag);
      document.addEventListener('touchend', this.stopMenuDrag);
    },
    onMenuDrag(event) {
      if (!this.isDraggingMenu) return;

      const currentX = event.clientX || event.touches[0].clientX;
      const currentY = event.clientY || event.touches[0].clientY;

      const deltaX = currentX - this.menuDragStart.x;
      const deltaY = currentY - this.menuDragStart.y;

      this.menuPosition.x += deltaX;
      this.menuPosition.y += deltaY;

      this.menuDragStart = {
        x: currentX,
        y: currentY
      };

      const menu = this.$el.querySelector('.v-menu__content');
      if (menu) {
        menu.style.transform = `translate(${this.menuPosition.x}px, ${this.menuPosition.y}px)`;
      }
    },
    stopMenuDrag() {
      this.isDraggingMenu = false;
      document.removeEventListener('mousemove', this.onMenuDrag);
      document.removeEventListener('mouseup', this.stopMenuDrag);
      document.removeEventListener('touchmove', this.onMenuDrag);
      document.removeEventListener('touchend', this.stopMenuDrag);
    }
  }
}
</script>